var winH = window.screen.height;   // Get the window height.

document.addEventListener("scroll", function () {
    if (document.scrollingElement.scrollTop > winH ) {
        document.querySelector('.tns-nav').style.display = "none";
    } else {
        document.querySelector('.tns-nav').style.display = "block";
    }
});

document.addEventListener("resize", function(){ // If the user resizes the window
    winH = window.screen.height; // you'll need the new height value
});